// const _LoginMenu = [
//   {
//     text: 'Inicio',
//     link: '/',
//     openInDiferentPage: false
//   },
//   {
//     text: 'Mis Cursos',
//     link: `${process.env.REACT_APP_API_PATH_GENERAL_CAMPUS}/campus/myAcademies`,
//     openInDiferentPage: true
//   },
//   {
//     text: 'Edu Store',
//     link: `${process.env.REACT_APP_API_PATH_GENERAL_CAMPUS}/store`,
//     openInDiferentPage: true
//   }
// ];

// exports.getLoginMenuData = function () {
//   return _LoginMenu;
// };

const _LoginMenu = [
  {
    text: 'start',
    link: '/',
    openInDiferentPage: false
  },
  {
    text: 'my_diploma',
    link: `${process.env.REACT_APP_API_PATH_GENERAL_CAMPUS}/myPortfolio`,
    openInDiferentPage: true
  },
  {
    text: 'my_profile',
    link: `${process.env.REACT_APP_API_PATH_GENERAL_CAMPUS}/myProfile/info`,
    openInDiferentPage: true
  },
  {
    text: 'student_campus',
    link: `${process.env.REACT_APP_API_PATH_GENERAL_CAMPUS}`,
    openInDiferentPage: true
  },
  {
    text: 'administrator_panel',
    link: `${process.env.REACT_APP_API_PATH_GENERAL_ADMIN}`,
    openInDiferentPage: true
  },
  {
    text: 'my_courses',
    link: `${process.env.REACT_APP_API_PATH_GENERAL_CAMPUS}/campus/myAcademies`,
    openInDiferentPage: true
  },
  {
    text: 'edu_store',
    link: `${process.env.REACT_APP_API_PATH_GENERAL_CAMPUS}/store`,
    openInDiferentPage: true
  }
];

exports.getLoginMenuData = function () {
  return _LoginMenu;
};
